import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/public/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'recover',
    loadChildren: () => import('./pages/public/recover/recover.module').then( m => m.RecoverPageModule)
  },
  {
    path: 'loans',
    loadChildren: () => import('./pages/loans/loans.module').then( m => m.LoansPageModule)
  },
  {
    path: 'loans/:email',
    loadChildren: () => import('./pages/loans/loans.module').then( m => m.LoansPageModule)
  },
  {
    path: 'loan-detail/:id',
    loadChildren: () => import('./pages/loan-detail/loan-detail.module').then( m => m.LoanDetailPageModule)
  },
  {
    path: 'draw-list/:id',
    loadChildren: () => import('./pages/draws/draw-list/draw-list.module').then( m => m.DrawListPageModule)
  },
  {
    path: 'new-draw/:id',
    loadChildren: () => import('./pages/draws/new-draw/new-draw.module').then( m => m.NewDrawPageModule)
  },
  {
    path: 'draw-detail/:id',
    loadChildren: () => import('./pages/draws/draw-detail/draw-detail.module').then( m => m.DrawDetailPageModule)
  },
  {
    path: 'pay-off-list/:id',
    loadChildren: () => import('./pages/payOff/pay-off-list/pay-off-list.module').then( m => m.PayOffListPageModule)
  },
  {
    path: 'pay-off-request/:id',
    loadChildren: () => import('./pages/payOff/pay-off-request/pay-off-request.module').then( m => m.PayOffRequestPageModule)
  },
  {
    path: 'payoff-detail/:id',
    loadChildren: () => import('./pages/payOff/pay-off-detail/pay-off-detail.module').then( m => m.PayOffDetailPageModule)
  },
  {
    path: 'new-extension/:id',
    loadChildren: () => import('./pages/extensions/new-extension/new-extension.module').then( m => m.NewExtensionPageModule)
  },
  {
    path: 'extension-detail/:id',
    loadChildren: () => import('./pages/extensions/extension-detail/extension-detail.module').then( m => m.ExtensionDetailPageModule)
  },
  {
    path: 'extension-list/:id',
    loadChildren: () => import('./pages/extensions/extension-list/extension-list.module').then( m => m.ExtensionListPageModule)
  },
  {
    path: 'payment-list/:id',
    loadChildren: () => import('./pages/payments/payment-list/payment-list.module').then( m => m.PaymentListPageModule)
  },
  {
    path: 'payment-detail/:id',
    loadChildren: () => import('./pages/payments/payment-detail/payment-detail.module').then( m => m.PaymentDetailPageModule)
  },
  {
    path: 'new-payment/:id',
    loadChildren: () => import('./pages/payments/new-payment/new-payment.module').then( m => m.NewPaymentPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then( m => m.DashboardPageModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./pages/admin/admin.module').then( m => m.AdminPageModule)
  },
  {
    path:'admin-draws/:id',
    loadChildren:()=> import ('./pages/admin/draw/admin-draw/admin-draw.module').then(m=> m.AdminDrawPageModule)
  },{
    path:'admin-payments/:id',
    loadChildren:()=> import ('./pages/admin/payment/admin-payment/admin-payment.module').then(m=> m.AdminPaymentPageModule)
  },
  {
    path:'admin-extensions/:id',
    loadChildren:()=> import ('./pages/admin/extension/admin-extension/admin-extension.module').then(m=> m.AdminExtensionPageModule)
  },
  {
    path:'admin-payoff/:id',
    loadChildren:()=> import ('./pages/admin/payoff/adminpayoff/adminpayoff.module').then(m=> m.AdminpayoffPageModule)
  },
  {
    path: 'recent-activity',
    loadChildren: () => import('./pages/recent-activity/recent-activity.module').then( m => m.RecentActivityPageModule)
  },
  {
    path: 'recent-activity/:email',
    loadChildren: () => import('./pages/recent-activity/recent-activity.module').then( m => m.RecentActivityPageModule)
  },
  {
    path: 'companies',
    loadChildren: () => import('./pages/companies/companies.module').then( m => m.CompaniesPageModule)
  },
  {
    path: 'companies/:id',
    loadChildren: () => import('./pages/companies/companies.module').then( m => m.CompaniesPageModule)
  },
  {
    path: 'change-password',
    loadChildren: () => import('./pages/change-password/change-password.module').then( m => m.ChangePasswordPageModule)
  },
  {
    path: 'dashboard-admin',
    loadChildren: () => import('./pages/admin/dashboard/dashboard.module').then( m => m.DashboardPageModule)
  },
  {
    path: 'transaction/:type',
    loadChildren: () => import('./pages/admin/transactions/transactions.module').then( m => m.TransactionsPageModule)
  },
  {
    path: 'search',
    loadChildren: () => import('./pages/admin/search/search.module').then( m => m.SearchPageModule)
  },
  {
    path: 'users',
    loadChildren: () => import('./pages/admin/user/user.module').then( m => m.UserPageModule)
  },
  {
    path: 'user-detail/:id',
    loadChildren: () => import('./pages/admin/user-detail/user-detail.module').then( m => m.UserDetailPageModule)
  },
  {
    path: 'user-detail',
    loadChildren: () => import('./pages/admin/user-detail/user-detail.module').then( m => m.UserDetailPageModule)
  },
  {
    path: 'borrower-information',
    loadChildren: () => import('./pages/application/borrower-information/borrower-information.module').then( m => m.BorrowerInformationPageModule)
  },
  {
    path: 'property-loan',
    loadChildren: () => import('./pages/application/property-loan/property-loan.module').then( m => m.PropertyLoanPageModule)
  },
  {
    path: 'experience',
    loadChildren: () => import('./pages/application/experience/experience.module').then( m => m.ExperiencePageModule)
  },
  {
    path: 'real-state-owned',
    loadChildren: () => import('./pages/application/real-state-owned/real-state-owned.module').then( m => m.RealStateOwnedPageModule)
  },
  {
    path: 'declaration',
    loadChildren: () => import('./pages/application/declaration/declaration.module').then( m => m.DeclarationPageModule)
  },
  {
    path: 'borrower-demographic-information',
    loadChildren: () => import('./pages/application/borrower-demographic-information/borrower-demographic-information.module').then( m => m.BorrowerDemographicInformationPageModule)
  },
  {
    path: 'disclosures-and-consents',
    loadChildren: () => import('./pages/application/disclosures-and-consents/disclosures-and-consents.module').then( m => m.DisclosuresAndConsentsPageModule)
  },
  {
    path: 'ecoa',
    loadChildren: () => import('./pages/application/ecoa/ecoa.module').then( m => m.EcoaPageModule)
  },
  {
    path: 'construction-reserve',
    loadChildren: () => import('./pages/application/construction-reserve/construction-reserve.module').then( m => m.ConstructionReservePageModule)
  },
  {
    path: 'borrower-signature-authorization',
    loadChildren: () => import('./pages/application/borrower-signature-authorization/borrower-signature-authorization.module').then( m => m.BorrowerSignatureAuthorizationPageModule)
  },
  {
    path: 'application/:id',
    loadChildren: () => import('./pages/application/application/application.module').then( m => m.ApplicationPageModule)
  },
  {
    path: 'application',
    loadChildren: () => import('./pages/application/application/application.module').then( m => m.ApplicationPageModule)
  },
  {
    path: 'apps',
    loadChildren: () => import('./pages/application/apps/apps.module').then( m => m.AppsPageModule)
  },
  {
    path: 'disclosure-applicant',
    loadChildren: () => import('./pages/application/disclosure-applicant/disclosure-applicant.module').then( m => m.DisclosureApplicantPageModule)
  },
  {
    path: 'push',
    loadChildren: () => import('./pages/push/push.module').then( m => m.PushPageModule)
  }




];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
